// External Libraries
import React from 'react';

// Assets
import RightArrow from '../../assets/single-right-arrow.png';
import DoubleRightArrow from '../../assets/double-right-arrow.png';
import LeftArrow from '../../assets/single-left-arrow.png';
import DoubleLeftArrow from '../../assets/double-left-arrow.png';
import DisabledDoubleLeftArrow from '../../assets/disabled-double-left-arrow.png';
import DisabledDoubleRightArrow from '../../assets/disabled-double-right-arrow.png';
import DisabledSingleRightArrow from '../../assets/disabled-single-right-arrow.png';
import DisabledSingleLeftArrow from '../../assets/disabled-single-left-arrow.png';

// Component imports
import Button from './Button';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handleFirst = () => {
    if (currentPage > 1) {
      onPageChange(1);
    }
  };

  const handleLast = () => {
    if (currentPage < totalPages) {
      onPageChange(totalPages);
    }
  };

  return (
    <div className="pagination-container">
      <div className="d-flex gap-10">
        <Button
          type="button"
          onClick={handleFirst}
          disabled={currentPage === 1}
          className="pagination-button"
        >
          <img
            src={currentPage === 1 ? DisabledDoubleLeftArrow : DoubleLeftArrow}
            className="arrow-icons"
            alt="Previous"
          />
        </Button>
        <Button
          type="button"
          onClick={handlePrevious}
          disabled={currentPage === 1}
          className="pagination-button"
        >
          <img
            src={currentPage === 1 ? DisabledSingleLeftArrow : LeftArrow}
            className="arrow-icons"
            alt="Previous"
          />
        </Button>
      </div>
      <span className="pagination-info">
        Page {currentPage} of {totalPages}
      </span>
      <div className="d-flex gap-10">
        <Button
          type="button"
          onClick={handleNext}
          disabled={currentPage === totalPages}
          className="pagination-button"
        >
          <img
            src={
              currentPage === totalPages ? DisabledSingleRightArrow : RightArrow
            }
            className="arrow-icons"
            alt="Next"
          />
        </Button>
        <Button
          type="button"
          onClick={handleLast}
          disabled={currentPage === totalPages}
          className="pagination-button"
        >
          <img
            src={
              currentPage === totalPages
                ? DisabledDoubleRightArrow
                : DoubleRightArrow
            }
            className="arrow-icons"
            alt="Next"
          />
        </Button>
      </div>
    </div>
  );
};

export default Pagination;
